<template>
    <div>
        <div class="detail-box">
            <el-tooltip class="item" effect="dark" content="返回" placement="top-start">
                    <i class="iconfont icon-fanhui1" @click="$router.go(-1)"></i>
                </el-tooltip>
            <route-title></route-title>
            <soft-ware-detail></soft-ware-detail>
        </div>
        <bottom-slider></bottom-slider>
    </div>
</template>

<script>
import SoftWareDetail from '../resourceLibrary/SoftWareDetail.vue'
import BottomSlider from '../sysHome/BottomSlider.vue'
    export default {
    components: { SoftWareDetail, BottomSlider },
    data(){
        return {
        }
    }    
    }
</script>

<style lang="less" scoped>
.detail-box{
    padding:16rem var(--padding) 10rem var(--padding);
    position: relative;
    background-color: #f8f8f8;
}
.icon-fanhui1{
    position: absolute;
    top: 16rem;
    left: calc(var(--padding) + 16rem);
    color: #000000;
    font-size: 2rem;
    cursor: pointer;
}
@media screen and (max-width:750px){
    .icon-fanhui1{
        left: 21rem;
    }
}
</style>